import { render, staticRenderFns } from "./BigView.vue?vue&type=template&id=186d126a&scoped=true&"
import script from "./BigView.vue?vue&type=script&lang=js&"
export * from "./BigView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186d126a",
  null
  
)

export default component.exports